'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//see src/resizer for the actual resizing code, this is just the DOM for the resize handle
var ResizeHandle = function ResizeHandle(props) {
    var classNames = ['mx_ResizeHandle'];
    if (props.vertical) {
        classNames.push('mx_ResizeHandle_vertical');
    } else {
        classNames.push('mx_ResizeHandle_horizontal');
    }
    if (props.reverse) {
        classNames.push('mx_ResizeHandle_reverse');
    }
    return _react2.default.createElement(
        'div',
        { className: classNames.join(' '), 'data-id': props.id },
        _react2.default.createElement('div', null)
    );
}; // eslint-disable-line no-unused-vars


ResizeHandle.propTypes = {
    vertical: _propTypes2.default.bool,
    reverse: _propTypes2.default.bool,
    id: _propTypes2.default.string
};

exports.default = ResizeHandle;
module.exports = exports['default'];
//# sourceMappingURL=ResizeHandle.js.map